import React from 'react'
import { useTranslation } from 'react-i18next'
import M_UploadFiles from 'src/components/M_Components/M_UploadFiles/M_UploadFiles'

export default function DigitalArchive() {

    const { t } = useTranslation()

    return (
        <div className='cardOrderService'>
            <div className='divTitleCard'>
                <div className='divSizeTitle'>
                    <div className='iconTitleCard'>
                        <img src="/icons/svgsDaNet/upload-1.5.svg"
                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                            alt="Address"
                        />
                    </div>
                    <div className='labelTitleCard'>
                        {t("DigitalArchive")}
                    </div>
                </div>
            </div>
            <div className='divComponentUploadFiles'>
                {/* 10000000 equivale a 10MB */}
                <M_UploadFiles
                    maxSize={10000000}
                />
            </div>
        </div>
    )
}